// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".latest-news-category-slot__wrapper[data-v-0fdd9027]{font-size:22px;white-space:nowrap;-o-text-overflow:ellipsis;text-overflow:ellipsis;overflow:hidden}@media (max-width:767px){.latest-news-category-slot__wrapper[data-v-0fdd9027]{font-size:20px;line-height:33px}}", ""]);
// Exports
module.exports = exports;
